import classnames from 'classnames';

import dibsCss from 'dibs-css';
import ChevronDown from 'dibs-icons/exports/ChevronDown.ts';
import ChevronUp from 'dibs-icons/exports/ChevronUp.ts';

import { viewLess, viewMore } from '../../shared/sharedMessages.jsx';

const readMoreLabelClassName = classnames(
    dibsCss.sassyFontBodyMediumHeavy,
    dibsCss.inlineFlex,
    dibsCss.itemsCenter,
    dibsCss.gapXxxsmall
);

export const pdpAccordionReadMoreLabel = (
    <span className={readMoreLabelClassName}>
        {viewMore}
        <ChevronDown variation="20" />
    </span>
);

export const pdpAccordionReadLessLabel = (
    <span className={readMoreLabelClassName}>
        {viewLess}
        <ChevronUp variation="20" />
    </span>
);

export const pdpAccordionReadMoreButtonClass = classnames(
    dibsCss.wAuto,
    dibsCss.inlineFlex,
    dibsCss.itemsCenter,
    dibsCss.textNoir
);

export const pdpAccordionReadMoreWrapperClass = classnames(
    dibsCss.flex,
    dibsCss.flexCol,
    dibsCss.gapXxsmall
);
